import type { CardBrand } from './constants';

export const CARD_ACCEPTANCE_MIN_ONE_HINT = 'At least one card network must remain selected.';

/** Networks merchants can toggle in Payments & Processing card acceptance. */
export const CARD_ACCEPTANCE_NETWORKS: readonly CardBrand[] = [
  'amex',
  'mastercard',
  'visa',
  'discover',
];

/** At least one network must remain accepted (non-empty rejected list is allowed). */
export function hasAtLeastOneAcceptedCardNetwork(
  nonAcceptedCardBrands?: CardBrand[] | null,
): boolean {
  const rejected = new Set(nonAcceptedCardBrands ?? []);
  return CARD_ACCEPTANCE_NETWORKS.some((brand) => !rejected.has(brand));
}
